import { Box, styled } from '@mui/material';

const StyledFooter = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '40px',
  marginTop: theme.spacing(4),
  boxSizing: 'border-box',
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(0, 4),
  lineHeight: 'normal'
}));

interface FooterProps {
  children: React.ReactNode | React.ReactNode[];
}

const Footer = ({ children }: FooterProps) => {
  return <StyledFooter>{children}</StyledFooter>;
};

export default Footer;
